import { c as _c } from "react/compiler-runtime";
import { IcoEyeCrossed16 } from '@onefootprint/icons';
import { Form, Tooltip } from '@onefootprint/ui';
import { useTranslation } from 'react-i18next';
import TextList from '@/components/text-list';
import Item from '@/playbook-builder/components/item';
import Section from '@/playbook-builder/components/section';
import type { IdentityDataNodeProps } from '@/playbook-builder/playbook-builder.types';
import type { FormIdentityData } from '../../collect-data-node/components/person/person.types';

// Listed in the order bifrost renders the fields, so the options read like the form the user sees.
const IDENTITY_CDOS = ['name', 'dob', 'email', 'phone_number', 'full_address', 'us_tax_id', 'ssn9', 'ssn4', 'us_legal_status', 'nationality'] as const;
type DisabledCdosSectionProps = {
  node: IdentityDataNodeProps;
  canEdit: boolean;
  isFirmEmployee: boolean;
};
export const DisabledCdosSection = t0 => {
  const $ = _c(71);
  const {
    node,
    canEdit,
    isFirmEmployee
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "collectData.person.disabledCdos"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("playbook-builder", t1);
  let t2;
  if ($[1] !== node.data.mustCollectData || $[2] !== node.data.optionalData) {
    t2 = [...node.data.mustCollectData, ...node.data.optionalData];
    $[1] = node.data.mustCollectData;
    $[2] = node.data.optionalData;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const collected = t2;
  let T0;
  let T1;
  let t10;
  let t11;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[4] !== canEdit || $[5] !== collected || $[6] !== isFirmEmployee || $[7] !== node.data.disabledCdos || $[8] !== t) {
    t11 = Symbol.for("react.early_return_sentinel");
    bb0: {
      let t12;
      if ($[20] !== collected) {
        t12 = cdo => collected.includes(cdo);
        $[20] = collected;
        $[21] = t12;
      } else {
        t12 = $[21];
      }
      const lockable = IDENTITY_CDOS.filter(t12);
      if (!isFirmEmployee) {
        let t13;
        if ($[22] !== node.data.disabledCdos) {
          t13 = cdo_0 => node.data.disabledCdos.includes(cdo_0);
          $[22] = node.data.disabledCdos;
          $[23] = t13;
        } else {
          t13 = $[23];
        }
        const locked = lockable.filter(t13);
        if (!locked.length) {
          t11 = null;
          break bb0;
        }
        let t14;
        if ($[24] !== t) {
          t14 = t(_temp);
          $[24] = t;
          $[25] = t14;
        } else {
          t14 = $[25];
        }
        let t15;
        if ($[26] !== t) {
          t15 = t(_temp2);
          $[26] = t;
          $[27] = t15;
        } else {
          t15 = $[27];
        }
        let t16;
        if ($[28] !== t) {
          t16 = cdo_1 => t($_1 => $_1.cdos[cdo_1]);
          $[28] = t;
          $[29] = t16;
        } else {
          t16 = $[29];
        }
        const t17 = <Item label={t15} value={<TextList items={locked.map(t16)} />} />;
        let t18;
        if ($[30] !== t) {
          t18 = t(_temp3);
          $[30] = t;
          $[31] = t18;
        } else {
          t18 = $[31];
        }
        let t19;
        if ($[32] !== t18) {
          t19 = <p className="text-caption-2 text-tertiary">{t18}</p>;
          $[32] = t18;
          $[33] = t19;
        } else {
          t19 = $[33];
        }
        let t20;
        if ($[34] !== t14 || $[35] !== t17 || $[36] !== t19) {
          t20 = <Section title={t14}>{t17}{t19}</Section>;
          $[34] = t14;
          $[35] = t17;
          $[36] = t19;
          $[37] = t20;
        } else {
          t20 = $[37];
        }
        t11 = t20;
        break bb0;
      }
      T1 = Section;
      if ($[38] !== t) {
        t9 = t(_temp4);
        $[38] = t;
        $[39] = t9;
      } else {
        t9 = $[39];
      }
      let t13;
      if ($[40] !== t) {
        t13 = t(_temp5);
        $[40] = t;
        $[41] = t13;
      } else {
        t13 = $[41];
      }
      let t14;
      if ($[42] === Symbol.for("react.memo_cache_sentinel")) {
        t14 = <div className="flex-shrink-0 text-tertiary"><IcoEyeCrossed16 /></div>;
        $[42] = t14;
      } else {
        t14 = $[42];
      }
      if ($[43] !== t13) {
        t10 = <Tooltip content={t13} side="left">{t14}</Tooltip>;
        $[43] = t13;
        $[44] = t10;
      } else {
        t10 = $[44];
      }
      t8 = "flex flex-col gap-2";
      T0 = Form.MultiSelect;
      t3 = !canEdit;
      t4 = "disabledCdos";
      if ($[45] !== t) {
        t5 = t(_temp6);
        $[45] = t;
        $[46] = t5;
      } else {
        t5 = $[46];
      }
      if ($[47] !== t) {
        t6 = t(_temp7);
        $[47] = t;
        $[48] = t6;
      } else {
        t6 = $[48];
      }
      let t15;
      if ($[49] !== t) {
        t15 = cdo_2 => ({
          value: cdo_2,
          label: t($_7 => $_7.cdos[cdo_2])
        });
        $[49] = t;
        $[50] = t15;
      } else {
        t15 = $[50];
      }
      t7 = lockable.map(t15);
    }
    $[4] = canEdit;
    $[5] = collected;
    $[6] = isFirmEmployee;
    $[7] = node.data.disabledCdos;
    $[8] = t;
    $[9] = T0;
    $[10] = T1;
    $[11] = t10;
    $[12] = t11;
    $[13] = t3;
    $[14] = t4;
    $[15] = t5;
    $[16] = t6;
    $[17] = t7;
    $[18] = t8;
    $[19] = t9;
  } else {
    T0 = $[9];
    T1 = $[10];
    t10 = $[11];
    t11 = $[12];
    t3 = $[13];
    t4 = $[14];
    t5 = $[15];
    t6 = $[16];
    t7 = $[17];
    t8 = $[18];
    t9 = $[19];
  }
  if (t11 !== Symbol.for("react.early_return_sentinel")) {
    return t11;
  }
  let t12;
  if ($[51] !== T0 || $[52] !== t3 || $[53] !== t4 || $[54] !== t5 || $[55] !== t6 || $[56] !== t7) {
    t12 = <T0 disabled={t3} name={t4} label={t5} placeholder={t6} options={t7} size="compact" />;
    $[51] = T0;
    $[52] = t3;
    $[53] = t4;
    $[54] = t5;
    $[55] = t6;
    $[56] = t7;
    $[57] = t12;
  } else {
    t12 = $[57];
  }
  let t13;
  if ($[58] !== t) {
    t13 = t(_temp8);
    $[58] = t;
    $[59] = t13;
  } else {
    t13 = $[59];
  }
  let t14;
  if ($[60] !== t13) {
    t14 = <p className="text-caption-2 text-tertiary">{t13}</p>;
    $[60] = t13;
    $[61] = t14;
  } else {
    t14 = $[61];
  }
  let t15;
  if ($[62] !== t12 || $[63] !== t14 || $[64] !== t8) {
    t15 = <div className={t8}>{t12}{t14}</div>;
    $[62] = t12;
    $[63] = t14;
    $[64] = t8;
    $[65] = t15;
  } else {
    t15 = $[65];
  }
  let t16;
  if ($[66] !== T1 || $[67] !== t10 || $[68] !== t15 || $[69] !== t9) {
    t16 = <T1 title={t9} actions={t10}>{t15}</T1>;
    $[66] = T1;
    $[67] = t10;
    $[68] = t15;
    $[69] = t9;
    $[70] = t16;
  } else {
    t16 = $[70];
  }
  return t16;
};
function _temp($) {
  return $.title;
}
function _temp2($_0) {
  return $_0.label;
}
function _temp3($_2) {
  return $_2.hint;
}
function _temp4($_3) {
  return $_3.title;
}
function _temp5($_4) {
  return $_4.employeeOnly;
}
function _temp6($_5) {
  return $_5.label;
}
function _temp7($_6) {
  return $_6.placeholder;
}
function _temp8($_8) {
  return $_8.hint;
}